import { Pipe, PipeTransform } from "@angular/core";
import { FullClient, FullClientType } from "@models/full-client.model";

@Pipe({
	name: "fullClientIcon",
	standalone: true,
})
export class FullClientIconPipe implements PipeTransform {
	transform(client: FullClient): string | null {
		if (!client) {
			return null;
		}
		return client.icone || (client.type === FullClientType.PS ? client.ico : null) || null;
	}
}
